// Autogenerated file
export const waybillTitleTypesEnum = {
    T1: "T1",
    T2: "T2",
    T3: "T3",
    T4: "T4",
    T5: "T5",
    T6: "T6",
    T7: "T7",
    T8: "T8",
};
export const waybillTitleTypes = [
    { label: "Т1 - Груз сдан отправителем", value: "T1" },
    { label: "Т2 - Груз принят перевозчиком", value: "T2" },
    { label: "Т3 - Груз принят получателем", value: "T3" },
    { label: "Т4 - Груз сдан перевозчиком", value: "T4" },
    { label: "Т5 - Согласование оплаты", value: "T5" },
    { label: "Т6 - Оплата согласована", value: "T6" },
    { label: "Т7 - Переадресовка", value: "T7" },
    { label: "Т8 - Замена водителя и (или) ТС", value: "T8" },
];
